import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cx from 'classnames';
import { connect } from 'react-redux'
import { flowRight as compose } from 'lodash'
import { graphql } from 'react-apollo';

import Link from '../../components/Link';
import SocialMediaSupport from './SocialMediaSupport';

import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import getContentPageDetails from './getContentPage.graphql';
import { getDynamicTitleByName, getDynamicTitleByLocale } from '../../helpers/getDynamicTitle';

import s from './Footer.css';
import bt from '../../components/commonStyle.css';

class Footer extends React.Component {
  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings } } = this.props
    const { getContentPageDetails: { getContentPageDetails } } = this.props;
    const { currentLocale } = this.props

    let homeSettings = {}, dynamicHomePageSettings = [], allFooterSectionData, footerSectionData, checkUrl;

    if (!loading && getAllHomePageSettings?.homePageData) {
      getAllHomePageSettings?.homePageData?.map((item) => {
        if (item?.dynamicHomePageSettings?.length > 0) {
          item?.dynamicHomePageSettings?.map((o) => {
            o['name'] = item?.name;
            dynamicHomePageSettings?.push(o);
          })
        } else {
          homeSettings[item?.name] = item?.value
        }
      })
    }

    allFooterSectionData = getDynamicTitleByName({ dynamicHomePageSettings, name: 'footerTitle1' });
    footerSectionData = getDynamicTitleByLocale({ dynamicHomePageSettings: allFooterSectionData, locale: currentLocale });
    footerSectionData = footerSectionData?.length > 0 ? footerSectionData[0] : allFooterSectionData[0];

    getContentPageDetails?.results?.map((item) => {
      if (item.isEnable == true) {
        checkUrl = 1;
      }
    })

    return (
      <div>
        {!loading && getAllHomePageSettings?.homePageData &&
          <div className={cx(s.footer, s.heroBkgAnimated, 'bgBlackTwo')} id="footer-section">
            <Container className={s.containerWith}>
              <Row>
                <Col lg={4} md={6} sm={12} xs={12} className={cx(bt.space3)}>
                  <SocialMediaSupport />
                </Col>

                <Col lg={4} md={6} sm={12} xs={12} className={cx(bt.space3)}>
                  <div className={cx(s.content)}>
                    <h3 className={cx('textAlignRightRTL', 'textWhite')}>{footerSectionData?.value}</h3>
                    <p className={cx('textAlignRightRTL', 'textWhite')}>
                      {footerSectionData?.description}
                    </p>
                  </div>
                </Col>

                {
                  checkUrl == 1 && <Col lg={4} md={6} sm={12} xs={12} className={cx(bt.space3)}>
                    <div className={cx(s.content, s.floatRight)}>
                      <h3 className={cx('textAlignRightRTL', 'textWhite')}>{footerSectionData?.urlTitle}</h3>
                      <ul className={cx('textAlignRightRTL', 'footerUselinkDark')}>
                        {
                          getContentPageDetails?.results?.length > 0 && getContentPageDetails?.results?.map((item, index) => {
                            return item?.isEnable ? (<li key={index}><Link to={'/' + item?.pageUrl}>{item?.pageTitle}</Link></li>) : (<span key={index}></span>);
                          })
                        }
                      </ul>
                    </div>
                  </Col>
                }
              </Row>
            </Container>
            <div className={cx(s.copyRight, 'textWhite')}>
              {homeSettings?.footerBottom}
            </div>
          </div>}
      </div>
    );
  }
}
const mapState = (state) => ({
  youtubeLink: state?.siteSettings?.data?.youtubeLink,
  twitterLink: state?.siteSettings?.data?.twitterLink,
  facebookLink: state?.siteSettings?.data?.facebookLink,
  instagramLink: state?.siteSettings?.data?.instagramLink,
  currentLocale: state?.intl?.locale
})

const mapDispatch = {
}

export default compose(
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  }),
  graphql(getContentPageDetails, {
    name: 'getContentPageDetails',
    options: {
      fetchPolicy: "network-only",
      ssr: false
    }
  })
)
  (Footer);
